import { useState } from 'react';

export const useSelectBranchOffice = () => {
	const [branchOfficeId, setBranchOfficeId] = useState<string>('total');

	return {
		branchOfficeId,
		handleSelectBranchOfficeId: setBranchOfficeId,
	};
};
